import type { BoardElementId, BoardElementType, WallCard, WallShape } from '@walls/store';
import { getSelectableBoardElements } from '../../positioning/cardRects';
import type { BoardRect } from './selectionGeometry';

interface SelectableElement {
  card?: WallCard;
  id: BoardElementId;
  rect: BoardRect;
  shape?: WallShape;
  type: BoardElementType;
}

export function getSelectableElements(
  cards: WallCard[],
  shapes: WallShape[],
  measuredRects: Record<string, BoardRect> = {}
): SelectableElement[] {
  return getSelectableBoardElements(cards, shapes).map(({ card, id, rect, shape, type }) => ({
    card,
    id,
    rect: measuredRects[id] ?? rect,
    shape,
    type,
  }));
}
